<template>
    <div id="live_list">
        <div class="bread">
            <el-breadcrumb>
                <el-breadcrumb-item :to="{ path: '/course_list' }">微吼直播列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="bottom cont">
            <div class="titlebox">
                    <div class="title">
                        微吼直播列表
                        <span v-if="link_User && userInfo" class="user-info">
                            （业务员：{{ link_User.yhmc }} / {{ userInfo.yhid }}）
                        </span>
                    </div>
                    <div class="notice">
                        <span class="right_grid">
                            <span class="refresh" @click="refresh">刷新</span>
                            <span v-if="link_User && userInfo" class="refresh logout-btn" @click="handleLogout">退出</span>
                        </span>
                    </div>
                </div>
            <div class="search-box" v-if="type == '_1'">
                <el-input v-model="searchKeyword" placeholder="请输入直播间名称" class="search-input" clearable @keyup.enter="handleSearch">
                    <template #append>
                        <el-button @click="handleSearch">搜索</el-button>
                    </template>
                </el-input>
            </div>
            <div class="string"></div>
            <!-- 表 -->
            <div class="table_box">
                <el-table v-loading="loading" :data="tableData" stripe style="width: 98%; margin: 0 auto" :height="tableHeight" :header-cell-style="{ backgroundColor: '#FAFAFA' }">
                    <el-table-column prop="theme" label="直播主题" min-width="360" align="left" :show-overflow-tooltip="true" fixed="left">
                        <template #default="scope">
                            <span>{{ scope.row.theme }}</span><br/>
                            [<span class="caozuo" @click="gotoPage(scope.row, 1, 'all')">全部</span>] [<span class="caozuo" @click="gotoPage(scope.row, 1, 'live')">直播</span>] [<span class="caozuo" @click="gotoPage(scope.row, 1, 'replay')">回放</span>]
                        </template>
                        <!-- <template #default="scope" v-else>
                            <span class="caozuo" @click="gotoPage(scope.row, 1, '')">{{scope.row.theme}}</span>
                        </template> -->
                    </el-table-column>
                    
                    <!-- <el-table-column sortable label="预约时间" width="180" align="left" fixed="left" :show-overflow-tooltip="true">
                        <template #default="scope">
                            <span>{{scope.row.yy_time.substr(0, scope.row.yy_time.indexOf("."))}}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column sortable label="直播时间" width="180" align="left"  :show-overflow-tooltip="true">
                        <template #default="scope">
                            <span>{{formatTime(scope.row.li_time)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="直播时长" width="120" align="left">
                        <template #default="scope">
                            <span>{{ scope.row.reserve_living_duration || "0秒" }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="观看人数" width="100" align="center">
                        <template #default="scope">
                            <span>{{ scope.row.viewer_num || 0 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column v-if="type==''" sortable label="资源开始时间" width="180" align="center">
                        <template #default="scope">
                            <span>{{scope.row.resourceStartDate.substr(0, scope.row.resourceStartDate.indexOf("."))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="type==''" sortable label="资源结束时间" width="180" align="center">
                        <template #default="scope">
                            <span>{{scope.row.resourceEndDate.substr(0, scope.row.resourceEndDate.indexOf("."))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="type==''" label="设置资源时间" width="120" align="center">
                        <template #default="scope">
                            <span v-if="scope.row.source_type==4" class="caozuo" @click="ShowSetDate(scope.row)">设置</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="直播地址" width="180" align="left" fixed="right">
                        <template #default="scope">
                            <span v-if="scope.row.source_type==4" class="caozuo" @click="CopyUrl2(scope.row)" style="margin-left: 8px;">公众号</span>
                            <span v-if="scope.row.source_type==4" class="caozuo" @click="CopyUrl(scope.row)">小程序</span>
                            <!-- <span v-if="scope.row.source_type==4" class="caozuo" @click="CopyUrl3(scope.row)" style="margin-left: 8px;">PC网页</span> -->
                        </template>
                    </el-table-column>
                </el-table>
                <el-row class="paging_box" justify="space-between">
                    <el-pagination class="paging" @size-change="sizeChange" @current-change="currentChange" :current-page="page.current" :page-sizes="page.pageSizes" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
                    </el-pagination>
                </el-row>
            </div>
        </div>
        <el-dialog v-model="dialogFormResourceDate" :title="'设置【' + (ResourceRow ? (ResourceRow.theme.substr(0, 20) + (ResourceRow.theme.length > 20? '...' : '')) : '') + '】资源时间'" width="510px">
            <el-form>
                <el-form-item label="选择时间" label-width="70px">
                    <el-date-picker v-model="ResourceDate" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="HideSetDate()">取 消</el-button>
                    <el-button type="primary" @click="SaveSetDate()">确 定</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import './assets/less/list.less'
import list_model from './model/model'
import common_model from '@/common/model'
import moment from 'moment/moment'
import { reactive } from 'vue'
import { ElMessageBox } from 'element-plus'
var that = null
export default {
    components: {},
    data() {
        that = this
        return {
            type: that.$route.query.type || '', //部门类型
            loading: false,
            tableHeight: 350,
            activeName: 'get_e_live_list',
            tableData: [],
            searchKeyword: '', // 搜索关键词
            page: {
                loading: false,
                pageSize: 10,
                total: 0,
                size: 10,
                current: 1,
                pageSizes: [10, 20, 50, 100],
            },
            link_User: null,

            dialogFormResourceDate: false,
            ResourceRow: null,
            ResourceDate: [
                new Date(2000, 10, 10, 10, 10),
                new Date(2000, 10, 11, 10, 10),
            ],
            copyUrlMsgBox: null, // 复制地址弹窗实例
        }
    },
    mounted() {
        that.$nextTick(() => {
            that.tableHeight =
                document.querySelector('.table_box').clientHeight - 34
            that.init()
        })
    },
    methods: {
        init() {
            //用户权限处理
            common_model.getUserInfoWithAccountFallback().then(
                (res) => {
                    that.userInfo = res
                    that.link_User = res
                    // console.log(that.link_User);
                    that.get_e_live_list()
                    if (that.type == '') {
                        list_model
                            .get_e_user_info({ crm_id: that.userInfo.yhid })
                            .then(
                                (res2) => {
                                    if (
                                        res2 &&
                                        res2.code == 0 &&
                                        res2.data.length > 0
                                    ) {
                                        that.link_User = res2.data[0]
                                        // console.log(that.link_User);
                                        
                                    }
                                    // that.get_e_live_list()
                                },
                                (error) => {
                                    // that.get_e_live_list()
                                }
                            )
                    } else {
                        // that.get_e_live_list()
                    }
                },
                (error) => {
                    console.log(error)
                    that.loading = false
                    that.tableData = []
                    that.page.total = 0
                }
            )
        },
        /**
         * 获取列表数据
         */
        /**
         * 处理搜索
         */
        handleSearch() {
            that.page.current = 1
            that.get_e_live_list()
        },

        /**
         * 获取列表数据
         */
        get_e_live_list() {
            if (!that.userInfo || !that.userInfo.yhid) {
                that.loading = false
                that.tableData = []
                that.page.total = 0
                return
            }
            that.loading = true
            let params = reactive({
                pageIndex: that.page.current,
                pageSize: that.page.size,
                type: 0,
            })

            // 如果有搜索关键词，添加到请求参数中
            if (that.searchKeyword && that.searchKeyword.trim() !== '') {
                params.keyword = that.searchKeyword.trim()
            } else if (that.type == '_1') {
                params.keyword = ''
            }
            let bmbm = that.userInfo && that.userInfo.bmbm ? that.userInfo.bmbm : ''
            list_model.get_e_live_list(params, that.type, bmbm).then((res) => {
                that.loading = false
                if (res.code === 0) {
                    // console.log(res)
                    that.tableData = res.list
                    that.page.total = res.total
                }
            })
        },
        /* 数据刷新 */
        refresh() {
            that.get_e_live_list()
        },
        /**
         * 退出登录，清理缓存
         */
        handleLogout() {
            localStorage.removeItem('fallback_ywy_user')
            that.userInfo = null
            that.link_User = null
            that.tableData = []
            that.page.total = 0
            that.loading = false
            that.$message.success('已退出')
        },
        /**
         * 分页-改变分页大小
         */
        sizeChange(v) {
            that.page.size = v
            that.page.current = 1
            that.get_e_live_list()
        },
        /**
         * 分页-当前页数据刷新
         */
        currentChange(v) {
            that.page.current = v
            that.get_e_live_list()
        },
        /**
         * 时间格式化
         * @param time 以秒为单位的时间戳
         */
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD')
        },
        /**
         * 格式化时间字符串，兼容多种格式
         * 例如：'2026-07-27 19:19:00.000'、'2026-07-27 19:19:00'、'2026-07-27T19:19:00.000Z'
         * @param timeStr 时间字符串
         */
        formatTime(timeStr) {
            if (!timeStr) return ''
            let result = timeStr
            const dotIndex = result.indexOf('.')
            if (dotIndex !== -1) {
                result = result.substr(0, dotIndex)
            }
            const tIndex = result.indexOf('T')
            if (tIndex !== -1) {
                result = result.replace('T', ' ')
            }
            return result
        },
        gotoPage(item, type, livetype) {
            let userInfo = that.userInfo
            let url =
                '/course?liveId=' + item.livingId + '&livetype=' + livetype
            if (!livetype) {
                url = '/course?liveId=' + item.livingId
            }

            if (that.type != '') url += '&type=' + that.type
            window.location.href = url
        },
        CopyUrl2(item){
            if (!that.userInfo || !that.userInfo.yhid) {
                that.$message.error('请先登录')
                return
            }
            var encode_url = "/live?livingid="+item.livingId+"&key="+that.userInfo.yhid+"&t="+Date.now()//时间戳
            var url = "https://articles.fzdhc.com.cn"+encode_url
            that.showCopyUrlDialog(url)
        },
        CopyUrl3(item){
            if (!that.userInfo || !that.userInfo.yhid) {
                that.$message.error('请先登录')
                return
            }
            var encode_url = "/live?livingid="+item.livingId+"&key="+that.userInfo.yhid+"&type=web"//时间戳
            var url = "https://articles.fzdhc.com.cn"+encode_url
            that.showCopyUrlDialog(url)
        },
        CopyUrl(item) {
            let params = {
                livingid: item.livingId,
                key: that.userInfo.yhid
            }
            that.loading = true
            let bmbm = that.userInfo && that.userInfo.bmbm
                ? that.userInfo.bmbm
                : ''
            list_model.get_mini_live_url(bmbm, params).then((res) => {
                that.loading = false
                if (res.code === 0) {
                    console.log(res)
                    let url = res.url
                    that.showCopyUrlDialog(url)
                }
            })
        },
        /**
         * 弹出复制地址对话框
         * @param url 直播地址
         */
        showCopyUrlDialog(url) {
            // 转义 HTML 特殊字符
            const safeUrl = that.escapeHtml(url)
            const htmlContent =
                '<div class="copy-url-dialog">' +
                '  <div class="copy-url-text" id="copy-url-text">' + safeUrl + '</div>' +
                '  <div class="copy-url-actions">' +
                '    <button type="button" class="copy-url-btn" id="copy-url-btn">复制到剪贴板</button>' +
                '  </div>' +
                '</div>'

            // 保留 OK 按钮（DOM 中存在），通过 CSS 隐藏
            // 这样 closeCopyDialog 可以通过点击 OK 按钮关闭弹窗
            that.copyUrlMsgBox = ElMessageBox({
                title: '直播地址',
                message: htmlContent,
                dangerouslyUseHTMLString: true,
                customClass: 'copy-url-message-box',
                showConfirmButton: true,    // 保留 OK 按钮 DOM
                showClose: true,
                showCancelButton: false,
                closeOnClickModal: true,
                closeOnPressEscape: true,
                confirmButtonText: '关闭',
            }).catch(() => {
                // 关闭时 reject，无需处理
            })

            // 等待 DOM 渲染完成后绑定复制按钮事件
            that.$nextTick(() => {
                const btn = document.getElementById('copy-url-btn')
                if (btn) {
                    btn.addEventListener('click', (e) => {
                        e.stopPropagation()
                        that.copyToClipboard(url, btn)
                    })
                }
            })
        },
        /**
         * 复制文本到剪贴板
         * @param text 要复制的文本
         * @param btn 触发的按钮元素（用于更新状态）
         */
        copyToClipboard(text, btn) {
            // 优先使用现代 API
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(
                    () => {
                        that.showCopySuccess(btn)
                    },
                    (err) => {
                        console.warn('clipboard API 失败，降级使用 execCommand', err)
                        that.fallbackCopy(text, btn)
                    }
                )
            } else {
                // 非安全上下文（如 HTTP）降级方案
                that.fallbackCopy(text, btn)
            }
        },
        /**
         * 降级复制方案（兼容旧浏览器和非安全上下文）
         */
        fallbackCopy(text, btn) {
            try {
                const textarea = document.createElement('textarea')
                textarea.value = text
                textarea.style.position = 'fixed'
                textarea.style.top = '-9999px'
                textarea.style.left = '-9999px'
                document.body.appendChild(textarea)
                textarea.focus()
                textarea.select()
                const successful = document.execCommand('copy')
                document.body.removeChild(textarea)
                if (successful) {
                    that.showCopySuccess(btn)
                } else {
                    that.showCopyFail(btn)
                }
            } catch (err) {
                console.error('复制失败', err)
                that.showCopyFail(btn)
            }
        },
        /**
         * 显示复制成功状态
         */
        showCopySuccess(btn) {
            if (!btn) return
            btn.innerText = '已复制 ✓'
            btn.classList.add('copy-url-btn-success')
            that.$message.success('直播地址已复制到剪贴板')
            // 800ms 后自动关闭弹窗
            setTimeout(() => {
                that.closeCopyDialog()
            }, 800)
        },
        /**
         * 关闭复制地址弹窗
         * 通过触发 OK 按钮的 click 事件关闭弹窗（OK 按钮被 CSS 隐藏但 DOM 存在）
         */
        closeCopyDialog() {
            // 找到 .copy-url-message-box 内的 OK 按钮
            const okBtn = document.querySelector(
                '.copy-url-message-box .el-message-box__btns .el-button--primary'
            )
            if (okBtn) {
                okBtn.click()
            } else {
                // 降级：找 .v-modal
                const overlay = document.querySelector('.v-modal')
                if (overlay) {
                    overlay.click()
                }
            }
        },
        /**
         * 显示复制失败状态
         */
        showCopyFail(btn) {
            if (!btn) return
            btn.innerText = '复制失败，请手动复制'
            btn.classList.add('copy-url-btn-fail')
            that.$message.error('复制失败，请手动选择文本复制')
            setTimeout(() => {
                btn.innerText = '复制到剪贴板'
                btn.classList.remove('copy-url-btn-fail')
            }, 3000)
        },
        /**
         * HTML 转义，防止注入
         */
        escapeHtml(str) {
            if (str == null) return ''
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
        },
        ShowSetDate(row) {
            this.dialogFormResourceDate = true
            this.ResourceRow = row
            if (row) {
                this.ResourceDate = [
                    new Date(
                        row.resourceStartDate.substr(
                            0,
                            row.resourceStartDate.indexOf('.')
                        )
                    ),
                    new Date(
                        row.resourceEndDate.substr(
                            0,
                            row.resourceEndDate.indexOf('.')
                        )
                    ),
                ]
            }
        },
        HideSetDate() {
            this.dialogFormResourceDate = false
            this.ResourceDate = null
        },
        SaveSetDate() {
            // console.log(this.ResourceDate)
            if (this.ResourceDate) {
                let livingId = this.ResourceRow.livingId
                let new_st = moment(this.ResourceDate[0]).format(
                    'YYYY-MM-DD HH:mm:ss'
                )
                let new_nt = moment(this.ResourceDate[1]).format(
                    'YYYY-MM-DD HH:mm:ss'
                )
                // console.log(livingId, new_st, new_nt)
                let rsd = this.ResourceRow.resourceStartDate
                let rnd = this.ResourceRow.resourceEndDate
                let old_st = rsd.substr(0, rsd.indexOf('.'))
                let old_nt = rnd.substr(0, rnd.indexOf('.'))
                // console.log(livingId, old_st, old_nt)
                if (new_st == old_st && new_nt == old_nt) {
                    this.HideSetDate()
                } else {
                    let par = {
                        livingid: livingId,
                        ksrq: new_st,
                        jsrq: new_nt,
                    }
                    list_model.e_live_edit_time(par).then(
                        (res2) => {
                            that.get_e_live_list()
                            this.HideSetDate()
                        },
                        (error) => {
                            that.get_e_live_list()
                            this.HideSetDate()
                        }
                    )
                }
            }
        },
    },
    filters: {},
}
</script>

<style>
* {
    padding: 0;
}

.user-info {
    font-size: 14px;
    color: #666;
    font-weight: normal;
    margin-left: 10px;
}

.logout-btn {
    color: #f56c6c;
    margin-left: 10px;
}

.logout-btn:hover {
    color: #f78989;
}

/* 复制地址弹窗样式 */
.copy-url-message-box {
    max-width: 600px;
}

/* 隐藏 Element Plus 自带的 OK 按钮（复制按钮已在内容里） */
.copy-url-message-box .el-message-box__btns {
    display: none !important;
}

/* 让 padding 紧凑一些，因为没有按钮了 */
.copy-url-message-box .el-message-box__content {
    padding: 20px 20px 0 20px !important;
}

.copy-url-dialog {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 4px 0;
}

.copy-url-text {
    word-wrap: break-word;
    word-break: break-all;
    padding: 12px 16px;
    background-color: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.6;
    color: #303133;
    user-select: all;
    -webkit-user-select: all;
    max-height: 200px;
    overflow-y: auto;
}

.copy-url-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.copy-url-btn {
    padding: 8px 20px;
    background-color: #409eff;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.2s;
    min-width: 140px;
}

.copy-url-btn:hover {
    background-color: #66b1ff;
}

.copy-url-btn:active {
    background-color: #3a8ee6;
}

/* 关闭按钮样式已移除（复制成功自动关闭弹窗） */

.copy-url-btn-success {
    background-color: #67c23a !important;
    cursor: default;
}

.copy-url-btn-success:hover {
    background-color: #67c23a !important;
}

.copy-url-btn-fail {
    background-color: #f56c6c !important;
    cursor: default;
}

.copy-url-btn-fail:hover {
    background-color: #f56c6c !important;
}
</style>
